import {
  LucideCircleCheck,
  LucideCircleX,
  LucideTriangleAlert,
} from 'lucide-react'
import { Toaster as SonnerToaster } from 'sonner'

export function Toaster() {
  return (
    <SonnerToaster
      closeButton
      richColors
      mobileOffset={16}
      offset={{ bottom: 76, right: 16 }}
      position="bottom-right"
      icons={{
        success: <LucideCircleCheck size={17} />,
        warning: <LucideTriangleAlert size={17} />,
        error: <LucideCircleX size={17} />,
      }}
      toastOptions={{
        className: '!items-start',
        classNames: {
          title: 'text-base !font-bold',
          description: 'text-base',
          icon: 'mt-[4px]',
        },
      }}
      visibleToasts={4}
    />
  )
}
